export const locales = {
    fr: "fr",
    en: "en",
  };
  
  export const localStorageLocaleKeyName = "locale"